import { Link } from 'react-router-dom';
import { guides } from '@/lib/guides';
import { brand } from '@/config/brand';

export function GuidesPage() {
  return (
    <article className="panel prose-page">
      <h1>Guides</h1>
      <p>
        Original explainers on how to read alcohol, calorie, and price
        comparisons on {brand.name}. Each guide uses the same methodology as the
        catalog — composition and value, not intoxication targets. For adults of
        legal drinking age.
      </p>
      <ul className="guide-list">
        {guides.map((g) => (
          <li key={g.slug}>
            <Link to={`/guides/${g.slug}/`}>
              <strong>{g.title}</strong>
            </Link>
            <p className="muted">{g.description}</p>
            <p className="muted">Updated {g.updated}</p>
          </li>
        ))}
      </ul>
      <p>
        Also see <Link to="/methodology/">Methodology</Link> and{' '}
        <Link to="/compare/">Compare</Link>.
      </p>
    </article>
  );
}
